var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("article", { staticClass: "post-teaser", class: _vm.post.type }, [
    _c("div", { staticClass: "content" }, [
      _c("p", { staticClass: "post-date" }, [_vm._v(_vm._s(_vm.post.date))]),
      _vm._v(" "),
      _c("p", { staticClass: "post-title" }, [
        _c("a", { attrs: { href: _vm.post.link } }, [
          _vm._v(_vm._s(_vm.post.title.rendered)),
        ]),
      ]),
      _vm._v(" "),
      _c("p", {
        staticClass: "post-desc",
        domProps: { innerHTML: _vm._s(_vm.post.excerpt.rendered) },
      }),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "button align-self-bottom",
          attrs: { href: _vm.post.link },
        },
        [_vm._v("Læs mere")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }